"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.camelToHyphenated = void 0;
const camelToHyphenated = (string) => string.replace(/([A-Z])/g, (g) => `-${g[0].toLowerCase()}`);
exports.camelToHyphenated = camelToHyphenated;
//# sourceMappingURL=helpers.js.map